// extracted by mini-css-extract-plugin
export default {"background":"_22PLb","circle":"_1HeFf","skeleton":"_1REXo","filledSkeleton":"_3bCkr","title":"K-UTk","star":"_1-bwD","roundStar":"HPG0U","plus":"_1fOCz"};